import React, { Component } from "react";
import { forgotPassword } from "../auth";
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    Alert,
    AlertTitle,
    CircularProgress,
    InputAdornment
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LockResetIcon from '@mui/icons-material/LockReset';
import SendIcon from '@mui/icons-material/Send';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';

class ForgotPassword extends Component {
    state = {
        email: "",
        message: "",
        error: "",
        loading: false
    };

    componentDidMount() {
        // ReactGA.initialize('UA-331790-15');
        // ReactGA.pageview('/passwordreset');
    };

    forgotPassword = e => {
        e.preventDefault();
        this.setState({ message: "", error: "", loading: true });

        const bodyData = {
            from: 'donotreply@sdsconsortium.com',
            email: this.state.email.trim().toLowerCase(),
            website: 'Substation Design Solutions Industry Consortium',
            webUrl: 'https://sdsconsortium.com'
        }

        forgotPassword(bodyData).then(data => {
            if (data.error) {
                console.log(data.error);
                this.setState({
                    error: data.error,
                    loading: false
                });
            } else {
                console.log(data.message);
                this.setState({
                    message: data.message,
                    email: '',
                    loading: false
                });
            }
        }).catch(err => {
            console.error("Error:", err);
            this.setState({
                error: "Failed to send reset link. Please try again.",
                loading: false
            });
        });
    };

    render() {
        return (
            <>
                {/* Hero Section */}
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #003E7E 0%, #0056A8 100%)',
                        color: 'white',
                        py: 6,
                        mb: 6
                    }}
                >
                    <Container maxWidth="sm">
                        <Box sx={{ textAlign: 'center' }}>
                            <LockResetIcon sx={{ fontSize: 64, mb: 2, opacity: 0.9 }} />
                            <Typography
                                variant="h3"
                                component="h1"
                                sx={{
                                    fontWeight: 700,
                                    mb: 2
                                }}
                            >
                                Reset Your Password
                            </Typography>
                            <Typography variant="h6" sx={{ opacity: 0.9 }}>
                                Enter your email address and we'll send you a link to reset your password
                            </Typography>
                        </Box>
                    </Container>
                </Box>

                {/* Form Section */}
                <Container maxWidth="sm" sx={{ mb: 8 }}>
                    {/* Success Alert */}
                    {this.state.message && (
                        <Alert
                            severity="success"
                            variant="filled"
                            sx={{ mb: 3, fontSize: '1rem' }}
                        >
                            <AlertTitle sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
                                Success!
                            </AlertTitle>
                            {this.state.message}
                        </Alert>
                    )}

                    {/* Error Alert */}
                    {this.state.error && (
                        <Alert
                            severity="error"
                            variant="filled"
                            sx={{ mb: 3, fontSize: '1rem' }}
                        >
                            <AlertTitle sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
                                Error
                            </AlertTitle>
                            {this.state.error}
                        </Alert>
                    )}

                    <Paper
                        elevation={3}
                        sx={{
                            p: 4,
                            borderRadius: 3
                        }}
                    >
                        <form onSubmit={this.forgotPassword}>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 600,
                                    mb: 3,
                                    color: '#003E7E'
                                }}
                            >
                                Password Recovery
                            </Typography>

                            <TextField
                                fullWidth
                                type="email"
                                label="Email Address"
                                placeholder="Enter your email address"
                                value={this.state.email}
                                onChange={e =>
                                    this.setState({
                                        email: e.target.value,
                                        message: "",
                                        error: ""
                                    })
                                }
                                required
                                autoFocus
                                disabled={this.state.loading}
                                variant="outlined"
                                sx={{ mb: 3 }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EmailIcon sx={{ color: '#003E7E' }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <Button
                                type="submit"
                                variant="contained"
                                size="large"
                                fullWidth
                                disabled={this.state.loading || !this.state.email}
                                startIcon={this.state.loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                                sx={{
                                    backgroundColor: '#FF6600',
                                    color: 'white',
                                    py: 1.5,
                                    fontSize: '1.1rem',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    borderRadius: '12px',
                                    mb: 2,
                                    '&:hover': {
                                        backgroundColor: '#e55a00',
                                    },
                                    '&:disabled': {
                                        backgroundColor: '#ccc'
                                    }
                                }}
                            >
                                {this.state.loading ? 'Sending...' : 'Send Password Reset Link'}
                            </Button>

                            <Box sx={{ textAlign: 'center', mt: 3 }}>
                                <Button
                                    component={Link}
                                    to="/signin"
                                    startIcon={<ArrowBackIcon />}
                                    sx={{
                                        color: '#003E7E',
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 62, 126, 0.08)'
                                        }
                                    }}
                                >
                                    Back to Sign In
                                </Button>
                            </Box>
                        </form>
                    </Paper>

                    {/* Help Text */}
                    <Box sx={{ mt: 4, textAlign: 'center' }}>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            Need help? Contact support at{' '}
                            <a
                                href="mailto:support@sdsconsortium.com"
                                style={{
                                    color: '#FF6600',
                                    textDecoration: 'none',
                                    fontWeight: 600
                                }}
                            >
                                support@sdsconsortium.com
                            </a>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Don't have an account?{' '}
                            <Link
                                to="/signup"
                                style={{
                                    color: '#003E7E',
                                    textDecoration: 'none',
                                    fontWeight: 600
                                }}
                            >
                                Sign up here
                            </Link>
                        </Typography>
                    </Box>
                </Container>
            </>
        );
    }
}

export default ForgotPassword;
